import { useSelector } from 'react-redux';
import { RootState } from '../../store/RootState';

const useLocationPermitSettings = () => {
  const { copyEnabled, printMergeDefault } = useSelector((state: RootState) => state.permits);
  return { copyEnabled, printMergeDefault };
};

export default useLocationPermitSettings;
